import { put, call, takeLatest, all } from 'redux-saga/effects'
import services from '../../services'
import {
  SIGN_IN,
  SIGN_IN_SUCCESS,
  SIGN_IN_ERROR,
  AUTO_SIGN_IN,
  SIGN_OUT,
  SIGN_OUT_SUCCESS,
  SIGN_OUT_ERROR,
  SIGN_UP,
  SIGN_UP_SUCCESS,
  SIGN_UP_ERROR,
  SEND_PASSWORD_RECOVERY_EMAIL,
  SEND_PASSWORD_RECOVERY_EMAIL_SUCCESS,
  SEND_PASSWORD_RECOVERY_EMAIL_ERROR,
  SignIn,
  RESET_PASSWORD,
  RESET_PASSWORD_ERROR,
  RESET_PASSWORD_SUCCESS,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_ERROR,
  CHANGE_PASSWORD_SUCCESS
} from '../types/auth'
import { GET_CURRENT_USER } from '../types/user/get-current-user'

function* signIn({ payload }: SignIn) {
  try {
    const { response, error } = yield call(services.auth.signIn, payload)
    if (error) {
      yield put({ type: SIGN_IN_ERROR, payload: error.response.status })
    } else {
      yield all([put({ type: SIGN_IN_SUCCESS, payload: response }), put({ type: GET_CURRENT_USER, payload: null })])
    }
  } catch { }
}

function* autoSignIn() {
  try {
    const { response, error } = yield call(services.auth.autoSignIn)
    if (error) {
      yield put({ type: SIGN_IN_ERROR, payload: error.response.status })
    } else {
      yield all([
        put({ type: SIGN_IN_SUCCESS, payload: response }),
        put({ type: GET_CURRENT_USER, payload: null })
      ])
    }
  } catch {
    yield put({ type: SIGN_IN_ERROR, payload: 'Error en la sesión' })
  }
}

function* signOut() {
  try {
    const result = yield call(services.auth.signOut)
    yield put({ type: SIGN_OUT_SUCCESS, payload: result })
  } catch (error) {
    yield put({ type: SIGN_OUT_ERROR, payload: error })
  }
}

function* signUp({ payload }) {
  try {
    const result = yield call(services.auth.signUp, payload)
    yield put({ type: SIGN_UP_SUCCESS, payload: result })
  } catch (error) {
    yield put({ type: SIGN_UP_ERROR, payload: error })
  }
}

function* sendRecoverPasswordEmail({ payload }: { payload: { email: string } }) {
  try {
    const { response, error } = yield call(services.auth.sendRecoverPassword, payload)
    if (error) {
      yield put({ type: SEND_PASSWORD_RECOVERY_EMAIL_ERROR, payload: error.response.status })
    } else {
      yield all([put({ type: SEND_PASSWORD_RECOVERY_EMAIL_SUCCESS, payload: response })])
    }
  } catch {
    yield put({ type: SEND_PASSWORD_RECOVERY_EMAIL_ERROR, payload: 'Error inesperado al enviar el correo de recuperacion de contraseña.' })
  }
}

function* resetPassword({ payload }) {
  try {
    const { response, error } = yield call(services.auth.resetPassword, payload)
    if (error) {
      yield put({ type: RESET_PASSWORD_ERROR, payload: error.response.status })
    } else {
      yield all([put({ type: RESET_PASSWORD_SUCCESS, payload: response })])
    }
  } catch {
    yield put({ type: RESET_PASSWORD_ERROR, payload: 'Error inesperado al enviar el correo de recuperacion de contraseña.' })
  }
}

function* changePassword({ payload }) {
  try {
    const { response, error } = yield call(services.auth.changePassword, payload)
    if (error) {
      yield put({ type: CHANGE_PASSWORD_ERROR, payload: error.response.status })
    } else {
      yield all([put({ type: CHANGE_PASSWORD_SUCCESS, payload: response })])
    }
  } catch {
    yield put({ type: CHANGE_PASSWORD_ERROR, payload: 'Error inesperado al enviar el correo de recuperacion de contraseña.' })
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<any>(SIGN_IN, signIn)
  yield takeLatest<any>(SIGN_OUT, signOut)
  yield takeLatest<any>(SIGN_UP, signUp)
  yield takeLatest<any>(AUTO_SIGN_IN, autoSignIn)
  yield takeLatest<any>(SEND_PASSWORD_RECOVERY_EMAIL, sendRecoverPasswordEmail)
  yield takeLatest<any>(RESET_PASSWORD, resetPassword)
  yield takeLatest<any>(CHANGE_PASSWORD, changePassword)
}
